import React, { useState } from 'react';
import {
    Box, Button, Grid, Typography, TextField, MenuItem,
    FormControl, Select, Checkbox, FormControlLabel,
    Switch, Paper, IconButton, SelectChangeEvent, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PercentIcon from '@mui/icons-material/Percent';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import GroupsIcon from '@mui/icons-material/Groups';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SearchBar from "../../../components/SearchBar";
import AddAdvisorPackage from '../../../Modals/addAdvisorPackage';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const FounderPassSettings = () => {
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(0);
    const [advisorySubTab, setAdvisorySubTab] = useState(0);
    const [openModal, setOpenModal] = useState(false);

    const [settings, setSettings] = useState({
        passNameEn: "Founder's Pass",
        passNameAr: "بطاقة المؤسسين",
        countdownDays: 60,
        autoRecognize: true,
        passEnabled: true,
        requiredTier: ['Premium'],
        rewardDiscount: 15,
        rewardSubscriptionTier: 'premium',
        rewardSubscriptionDuration: 1,
        rewardCommissionPercent: 60,
        rewardCommissionDays: 30,
        rewardCommissionSalesValue: 1000,
        rewardPrioritySupportDays: 30,
        rewardPrioritySupport: true,
        rewardFeaturedBadgeDays: 30,
        rewardFeaturedBadge: true
    });

    const [advisorPackages] = useState([
        { id: 1, name: 'Standard Strategy', type: 'Video Call', duration: 30, price: 150, recommended: true },
        { id: 2, name: 'Premium Growth', type: 'Voice Call', duration: 60, price: 250, recommended: false },
        { id: 3, name: 'Expert Consult', type: 'Chat', duration: 45, price: 100, recommended: false },
    ]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setSettings(prev => ({
            ...prev,
            [name!]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSelectChange = (e: SelectChangeEvent<string>) => {
        const { name, value } = e.target;
        setSettings(prev => ({
            ...prev,
            [name!]: value
        }));
    };

    const handleSwitchChange = (name: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setSettings(prev => ({ ...prev, [name]: e.target.checked }));
    };

    return (
        <div className="founder_pass_wrapper">
            <div className="main_title">
                <h1>Founder Pass & Advisor Settings</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Founder Pass & Advisor Settings
                </p>
            </div>


            <Box className="custom_tabs mt_20">
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    className="custom_tabs_links"
                >
                    <Tab label="Founder's Pass Settings" {...a11yProps(0)} />
                    <Tab label="Business Advisor Management" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={tabValue} index={0}>
                <div className="table_flex">
                    <div className="lt">
                        <div className="cards" style={{ padding: '0px' }}>
                            <div className="table_header" style={{ borderBottom: '1px solid #eef0f4', marginBottom: '20px' }}>
                                <div className="left_s">
                                    <h3>Founder's Pass Configuration</h3>
                                </div>
                                <div className="right_s">
                                    <Button
                                        className="btn btn_primary sm"
                                        startIcon={<SaveIcon />}
                                        onClick={() => { }}
                                    >
                                        Save Changes
                                    </Button>
                                </div>
                            </div>

                            <div style={{ padding: '0 20px 20px 20px' }}>
                                <Grid container spacing={3}>
                                    {/* Pass Settings */}
                                    <Grid item xs={12} md={7}>
                                        <Paper className="form_card" elevation={0} style={{ border: '1px solid #eef0f4' }}>
                                            <div className="card_header_with_icon">
                                                <div className="icon_wrapper orange">
                                                    <WorkspacePremiumIcon />
                                                </div>
                                                <div className="title_info">
                                                    <h3>Pass Settings</h3>
                                                    <span>Basic configuration</span>
                                                </div>
                                            </div>

                                            <div className="form">
                                                <div className="gap_m w_100">
                                                    <div className="control_group w_50">
                                                        <label htmlFor="passNameEn">Pass Name</label>
                                                        <TextField
                                                            fullWidth
                                                            id="passNameEn"
                                                            name="passNameEn"
                                                            value={settings.passNameEn}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="control_group w_50">
                                                        <label htmlFor="countdownDays">Countdown Days</label>
                                                        <TextField
                                                            fullWidth
                                                            type="number"
                                                            id="countdownDays"
                                                            name="countdownDays"
                                                            value={settings.countdownDays}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="toggle_group w_100 d_flex_toggle">
                                                        <label htmlFor="autoRecognize">Auto-recognize on seller signup</label>
                                                        <Switch
                                                            id="autoRecognize"
                                                            checked={settings.autoRecognize}
                                                            onChange={handleSwitchChange('autoRecognize')}
                                                            color="primary"
                                                        />
                                                    </div>
                                                    <div className="toggle_group w_100 d_flex_toggle">
                                                        <label htmlFor="passEnabled">Pass Enabled</label>
                                                        <Switch
                                                            id="passEnabled"
                                                            checked={settings.passEnabled}
                                                            onChange={handleSwitchChange('passEnabled')}
                                                            color="primary"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Paper>
                                    </Grid>

                                    {/* Eligibility Rules */}
                                    <Grid item xs={12} md={5}>
                                        <Paper className="form_card" elevation={0} style={{ border: '1px solid #eef0f4' }}>
                                            <div className="card_header_plain">
                                                <h3>Eligibility Rules</h3>
                                            </div>

                                            <div className="form">
                                                <div className="gap_s w_100">
                                                    <div className="control_group_row d_flex_between w_100">
                                                        <label htmlFor="requiredTier">Required tier</label>
                                                        <FormControl size="small" style={{ width: '150px' }}>
                                                            <Select
                                                                id="requiredTier"
                                                                name="requiredTier"
                                                                multiple
                                                                value={Array.isArray(settings.requiredTier) ? settings.requiredTier : [settings.requiredTier as string]}
                                                                onChange={(e) => setSettings({...settings, requiredTier: typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value})}
                                                            >
                                                                <MenuItem value="Free">Free</MenuItem>
                                                                <MenuItem value="Premium">Premium</MenuItem>
                                                                <MenuItem value="Enterprise">Enterprise</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                            </div>
                                        </Paper>
                                    </Grid>

                                    {/* Rewards Configuration */}
                                    <Grid item xs={12}>
                                        <Paper className="form_card" elevation={0} style={{ border: '1px solid #eef0f4' }}>
                                            <div className="card_header_plain">
                                                <h3>Rewards Configuration</h3>
                                            </div>

                                            <div className="rewards_grid" style={{ alignItems: 'flex-start' }}>
                                                {/* AI Credits */}
                                                <div className="reward_item green">
                                                    <div className="reward_icon">
                                                        <AutoAwesomeIcon />
                                                    </div>
                                                    <div className="reward_input_box">
                                                        <input
                                                            type="number"
                                                            id="rewardDiscount"
                                                            name="rewardDiscount"
                                                            value={settings.rewardDiscount}
                                                            onChange={handleChange as any}
                                                        />
                                                    </div>
                                                    <label htmlFor="rewardDiscount"><strong style={{ color: "red" }}>AI Credits</strong></label>
                                                </div>

                                                {/* Free Upgrade */}
                                                <div className="reward_item blue" style={{flexDirection: 'column', alignItems: 'center', gap: '8px', minHeight: '180px'}}>
                                                    <label style={{fontWeight: 600, fontSize: '13px', textAlign: 'center', width: '100%', marginBottom: '5px'}}>Subscription Upgrade</label>
                                                    
                                                    <div style={{ width: '100%', textAlign: 'center' }}>
                                                        <label style={{fontSize: '11px', color: '#666', display: 'block'}}>Subscription Tier</label>
                                                        <Select size="small" fullWidth value={settings.rewardSubscriptionTier || 'premium'} onChange={(e) => setSettings({...settings, rewardSubscriptionTier: e.target.value as string})} name="rewardSubscriptionTier" style={{backgroundColor: '#fff'}}>
                                                            <MenuItem value="basic">Basic</MenuItem>
                                                            <MenuItem value="premium">Premium</MenuItem>
                                                            <MenuItem value="enterprise">Enterprise</MenuItem>
                                                        </Select>
                                                    </div>
                                                    
                                                    <div style={{ width: '100%', textAlign: 'center' }}>
                                                        <label style={{fontSize: '11px', color: '#666', display: 'block'}}>Duration (months)</label>
                                                        <div className="reward_input_box" style={{ margin: '0 auto', width: '60px' }}>
                                                            <input
                                                                type="number"
                                                                name="rewardSubscriptionDuration"
                                                                value={settings.rewardSubscriptionDuration || 1}
                                                                onChange={handleChange as any}
                                                                style={{width: '100%', padding: '6px 10px', boxSizing: 'border-box', textAlign: 'center'}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* No Commission */}
                                                <div className="reward_item purple" style={{flexDirection: 'column', alignItems: 'center', gap: '6px', minHeight: '180px'}}>
                                                    <label style={{fontWeight: 600, fontSize: '13px', textAlign: 'center', width: '100%'}}> Commission</label>
                                                    
                                                    <div className="d_flex_between w_100" style={{ gap: '5px', justifyContent: 'center' }}>
                                                        <div className="reward_input_box" style={{ margin: 0, width: '100px' }}>
                                                            <input
                                                                type="number"
                                                                name="rewardCommissionPercent"
                                                                value={settings.rewardCommissionPercent || 60}
                                                                onChange={handleChange as any}
                                                                style={{width: '100%', padding: '4px', textAlign: 'center'}}
                                                            />
                                                        </div>
                                                        <span style={{flexShrink: 0, fontSize: '12px', width: '30px', fontWeight: 600, color: 'purple'}}>%</span>
                                                    </div>

                                                    <div className="d_flex_between w_100" style={{ gap: '5px', justifyContent: 'center' }}>
                                                        <div className="reward_input_box" style={{ margin: 0, width: '100px' }}>
                                                            <input
                                                                type="number"
                                                                name="rewardCommissionDays"
                                                                value={settings.rewardCommissionDays || 30}
                                                                onChange={handleChange as any}
                                                                style={{width: '100%', padding: '4px', textAlign: 'center'}}
                                                            />
                                                        </div>
                                                        <span style={{flexShrink: 0, fontSize: '12px', width: '30px'}}>Days</span>
                                                    </div>

                                                    <div className="d_flex_between w_100" style={{ gap: '5px', justifyContent: 'center' }}>
                                                        <div className="reward_input_box" style={{ margin: 0, width: '100px' }}>
                                                            <input
                                                                type="number"
                                                                name="rewardCommissionSalesValue"
                                                                value={settings.rewardCommissionSalesValue || 1000}
                                                                onChange={handleChange as any}
                                                                style={{width: '100%', padding: '4px', textAlign: 'center'}}
                                                            />
                                                        </div>
                                                        <span style={{flexShrink: 0, fontSize: '12px', width: '30px'}}>AED</span>
                                                    </div>
                                                </div>

                                                {/* Priority Support */}
                                                <div className="reward_item yellow">
                                                        <label style={{marginBottom: '10px', fontSize: '11px', color: '#166534', fontWeight: 'bold'}}>No. of days</label>
                                                    <div className="reward_input_box" style={{ width: '60px', marginBottom: '5px' }}>
                                                        <input
                                                            type="number"
                                                            name="rewardPrioritySupportDays"
                                                            value={settings.rewardPrioritySupportDays || 30}
                                                            onChange={handleChange as any}
                                                            style={{ width: '100%', padding: '6px', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                    <div className="reward_icon">
                                                        <GroupsIcon />
                                                    </div>
                                                  
                                                    <label htmlFor="rewardPrioritySupport" style={{ marginTop: '-5px' }}>Priority Support</label>
                                                </div>

                                                {/* Featured Badge */}
                                                <div className="reward_item pink">
                                                        <label style={{marginBottom: '10px', fontSize: '11px', color: '#166534', fontWeight: 'bold'}}>No. of days</label>
                                                    <div className="reward_input_box" style={{ width: '60px', marginBottom: '5px' }}>
                                                        <input
                                                            type="number"
                                                            name="rewardFeaturedBadgeDays"
                                                            value={settings.rewardFeaturedBadgeDays || 30}
                                                            onChange={handleChange as any}
                                                            style={{ width: '100%', padding: '6px', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                    <div className="reward_icon">
                                                        <MilitaryTechIcon />
                                                    </div>
                                                 
                                                    <label htmlFor="rewardFeaturedBadge" style={{ marginTop: '-5px' }}>Featured Launch Badge</label>
                                                </div>
                                            </div>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>

                    <div className="rt">
                        <div className="ai_panel">
                            <h4>Eligibility Insights</h4>
                            <div className="ai_alert info" style={{ display: 'block' }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '5px', color: '#1e40af' }}>Pass Impact</div>
                                <p style={{ fontSize: '12px', color: '#1e3a8a' }}>
                                    Founders Pass currently rewards 45% of new signups.
                                </p>
                            </div>
                            <div className="ai_alert warning" style={{ display: 'block', marginTop: '10px' }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '5px', color: '#92400e' }}>Optimization Tip</div>
                                <p style={{ fontSize: '12px', color: '#78350f' }}>
                                    Increasing "Min ideas" to 3 could improve lead quality by 20%.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            <CustomTabPanel value={tabValue} index={1}>
                <div className="table_flex">
                    <div className="lt">
                        <div className="cards">
                            {/* Filter Section */}
                            <div className="table_header" style={{ flexWrap: 'wrap', gap: '10px' }}>
                                <div className="left_s" style={{ flex: 1, gap: '10px' }}>
                                    <Box className="search_box" style={{ minWidth: '200px' }}>
                                        <SearchBar
                                            searchTerm={""}
                                            setDebouncedSearchTerm={() => { }}
                                            placeholder="Search packages..."
                                        />
                                    </Box>
                                    <div className="form" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                        <div className="control_group">
                                            <select style={{ minWidth: '130px' }}>
                                                <option>All Types</option>
                                                <option>Video Call</option>
                                                <option>Voice Call</option>
                                                <option>Chat</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="right_s">
                                    <Button
                                        className="btn btn_primary sm"
                                        startIcon={<AddIcon />}
                                        onClick={() => setOpenModal(true)}
                                    >
                                        Add Package
                                    </Button>
                                </div>
                            </div>

                            <div style={{ padding: '0 0px 20px 0px' }}>
                                <h3>Advisor Packages</h3>
                            </div>

                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Package Name</TableCell>
                                            <TableCell>Session Type</TableCell>
                                            <TableCell>Duration</TableCell>
                                            <TableCell>Price (AED)</TableCell>
                                            <TableCell>Recommended</TableCell>
                                            <TableCell align="right">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {advisorPackages.map((pkg) => (
                                            <TableRow key={pkg.id} hover>
                                                <TableCell sx={{ fontWeight: 600 }}>{pkg.name}</TableCell>
                                                <TableCell>{pkg.type}</TableCell>
                                                <TableCell>{pkg.duration} min</TableCell>
                                                <TableCell>{pkg.price}</TableCell>
                                                <TableCell>
                                                    <span className={`badge1 ${pkg.recommended ? 'success' : 'warning'}`}>
                                                        {pkg.recommended ? 'Yes' : 'No'}
                                                    </span>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <div className="table_actions v2">
                                                        <IconButton size="small" onClick={() => setOpenModal(true)}>
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton size="small">
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        {/* Advisory Management Table */}
                        <div className="cards mt_20">

                            <div style={{ padding: '0 20px 0px 0px' }}>
                                <h3>Users</h3>
                            </div>
                            <Box className="custom_tabs" sx={{ borderBottom: '1px solid #f1f5f9', px: 2, pt: 1 }}>
                                <Tabs
                                    value={advisorySubTab}
                                    onChange={(e, v) => setAdvisorySubTab(v)}
                                    className="custom_tabs_links"
                                    sx={{ minHeight: '40px' }}
                                >
                                    <Tab label="Booked Advisory" {...a11yProps(0)} sx={{ py: 1, minHeight: '40px' }} />
                                    <Tab label="Received Advice" {...a11yProps(1)} sx={{ py: 1, minHeight: '40px' }} />
                                </Tabs>
                            </Box>

                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Date & Time</TableCell>
                                            <TableCell>Package Name</TableCell>
                                            <TableCell>User Details</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell align="right">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(advisorySubTab === 0 ? [
                                            { id: 1, date: '2024-02-12', time: '10:30 AM', user: 'Arpit Jain', email: 'arpit@example.com', pkg: 'Standard Strategy', status: 'Pending' },
                                            { id: 2, date: '2024-02-12', time: '02:15 PM', user: 'John Doe', email: 'john@example.com', pkg: 'Premium Growth', status: 'Accepted' },
                                        ] : [
                                            { id: 3, date: '2024-02-10', time: '11:00 AM', user: 'Sarah Smith', email: 'sarah@example.com', pkg: 'Expert Consult', status: 'Completed' },
                                            { id: 4, date: '2024-02-09', time: '04:00 PM', user: 'Mike Ross', email: 'mike@example.com', pkg: 'Standard Strategy', status: 'Completed' },
                                        ]).map((row) => (
                                            <TableRow key={row.id} hover>
                                                <TableCell>
                                                    <div style={{ fontSize: '13px' }}>
                                                        <div style={{ fontWeight: 600 }}>{row.date}</div>
                                                        <div style={{ color: '#64748b' }}>{row.time}</div>
                                                    </div>
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>{row.pkg}</TableCell>
                                                <TableCell>
                                                    <div style={{ fontSize: '13px' }}>
                                                        <div style={{ fontWeight: 600 }}>{row.user}</div>
                                                        <div style={{ color: '#64748b' }}>{row.email}</div>
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <FormControl size="small" variant="outlined" className='form'>
                                                        <Select
                                                            value={row.status}
                                                            onChange={() => { }}
                                                            className={`status_select_small ${row.status.toLowerCase()}`}
                                                            sx={{
                                                                height: '32px',
                                                                fontSize: '12px',
                                                                '.MuiSelect-select': { py: '4px' }
                                                            }}
                                                        >
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Accepted">Accepted</MenuItem>
                                                            <MenuItem value="Rejected">Rejected</MenuItem>
                                                            <MenuItem value="Completed">Completed</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => navigate('/manage-customers/view-customer')}
                                                    >
                                                        <VisibilityOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        {/* Stats Summary Below Tables */}
                        <div className="cards mt_20" style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="stat_item">
                                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#374151', marginBottom: '5px' }}>124 <span style={{ fontSize: '14px', color: '#666', fontWeight: 'normal' }}>Total Consultations</span></h2>
                                <p style={{ color: '#666', fontSize: '12px' }}>
                                    <span style={{ fontWeight: 'bold' }}>&#x21ba; 12</span> This Week
                                </p>
                            </div>
                            <div className="stat_item">
                                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#059669', marginBottom: '5px' }}>98% <span style={{ fontSize: '14px', color: '#666', fontWeight: 'normal' }}>Satisfaction Rate</span></h2>
                                <p style={{ color: '#666', fontSize: '12px' }}>
                                    <span style={{ fontWeight: 'bold' }}>&uarr; 3%</span> vs last month
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="rt">
                        <div className="ai_panel">
                            <h4>Advisor Insights</h4>

                            <div className="ai_alert warning" style={{ display: 'block', borderLeft: '4px solid #d97706' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', color: '#374151' }}>
                                        <PercentIcon style={{ color: '#d97706' }} /> Popular Package
                                    </div>
                                </div>
                                <p style={{ fontSize: '12px', marginBottom: '15px', color: '#666' }}>
                                    "Expert Consult" is the most picked package this month (45 picks).
                                </p>
                                <Button fullWidth variant="contained" style={{ backgroundColor: '#fff7ed', color: '#9a3412', textTransform: 'none', boxShadow: 'none', border: '1px solid #ffedd5' }}>Promote Package</Button>
                            </div>

                            <div className="ai_alert success" style={{ display: 'block', backgroundColor: '#f0fdf4', border: '1px solid #dcfce7' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', color: '#166534' }}>
                                        <CheckCircleOutlineIcon style={{ fontSize: 18 }} /> High Revenue Type
                                    </div>
                                </div>
                                <p style={{ fontSize: '12px', marginBottom: '10px', color: '#14532d' }}>
                                    Video calls generate 65% of advisor revenue.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            <AddAdvisorPackage open={openModal} handleClose={() => setOpenModal(false)} />
        </div >
    );
};

export default FounderPassSettings;
